import React, { useEffect, useState } from "react"
import { API_URL } from "../../utils/config"
import { yandexWidget } from "../../utils/yandexWidget"

// tog'a 1179 (2026-09-04): akkauntsiz qabul qiluvchi uchun OCHIQ sahifa — dostavkani havola (token) orqali tasdiqlash/rad etish.
// Auth yo'q: token URL'da (/delivery/confirm/<token>), server faqat token bo'yicha topadi. Ruscha + o'zbekcha.
export default function DeliveryConfirmPublic() {
  const token = (window.location.pathname.split("/delivery/confirm/")[1] || "").split(/[/?#]/)[0]
  const [info, setInfo] = useState<any>(null)
  const [state, setState] = useState<"loading" | "ready" | "notfound" | "done" | "rejected" | "error">("loading")
  const [reason, setReason] = useState("")
  const [busy, setBusy] = useState(false)
  const api = (p: string, init?: RequestInit) =>
    fetch(`${API_URL}Deliveries/Public/${token}${p}`, { ...init, headers: { "Content-Type": "application/json", ...((init && init.headers) || {}) } })

  useEffect(() => {
    if (!token) { setState("notfound"); return }
    const load = (first: boolean) =>
      api("")
        .then(async (r) => {
          if (!r.ok) { if (first) setState("notfound"); return }
          const j = await r.json()
          setInfo(j)
          // keyingi yangilanishlar faqat ma'lumotni yangilaydi — foydalanuvchi bosgan natija (done/rejected) o'chmasin
          if (first) setState(j.status === 2 ? "done" : j.status === 3 ? "rejected" : "ready")
        })
        .catch(() => { if (first) setState("error") })
    load(true)
    // tog'a #342 / #6024: yo'lda — haydovchi nuqtasi va ETA har 30 s yangilanadi
    const t = setInterval(() => load(false), 30000)
    return () => clearInterval(t)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token])

  const confirm = async () => {
    setBusy(true)
    try { const r = await api("/confirm", { method: "POST" }); setState(r.ok ? "done" : "error") } catch { setState("error") }
    setBusy(false)
  }
  const reject = async () => {
    if (!reason.trim()) { window.alert("Укажите причину / Sababini yozing"); return }
    setBusy(true)
    try { const r = await api("/reject", { method: "POST", body: JSON.stringify({ reason }) }); setState(r.ok ? "rejected" : "error") } catch { setState("error") }
    setBusy(false)
  }

  const box: React.CSSProperties = { maxWidth: 480, margin: "24px auto", padding: 20, borderRadius: 12, background: "#fff", color: "#0f172a", boxShadow: "0 8px 30px rgba(0,0,0,.12)", fontFamily: "system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif" }
  const btn = (bg: string): React.CSSProperties => ({ flex: 1, padding: "14px 10px", border: 0, borderRadius: 10, background: bg, color: "#fff", fontSize: 16, fontWeight: 600, cursor: "pointer", opacity: busy ? 0.6 : 1 })
  const row = (l: string, v: any) =>
    v ? (
      <div style={{ display: "flex", justifyContent: "space-between", gap: 12, padding: "6px 0", borderBottom: "1px solid #e2e8f0", fontSize: 14 }}>
        <span style={{ color: "#64748b" }}>{l}</span>
        <b style={{ textAlign: "right" }}>{v}</b>
      </div>
    ) : null

  return (
    <div style={{ minHeight: "100vh", background: "#000000", padding: 12, boxSizing: "border-box" }}>
      <div style={box}>
        <div style={{ fontSize: 13, color: "#64748b", marginBottom: 4 }}>SAV ERP · Логистика</div>
        <h2 style={{ margin: "0 0 12px", fontSize: 20 }}>
          Подтверждение доставки <span style={{ fontSize: 13, color: "#64748b", fontWeight: 400 }}>/ Yetkazib berishni tasdiqlash</span>
        </h2>
        {state === "loading" && <p>Загрузка… / Yuklanmoqda…</p>}
        {state === "notfound" && <p style={{ color: "#b91c1c" }}>Ссылка недействительна или устарела. / Havola noto'g'ri yoki eskirgan.</p>}
        {state === "error" && <p style={{ color: "#b91c1c" }}>Ошибка. Попробуйте позже. / Xatolik, keyinroq urinib ko'ring.</p>}
        {info && (state === "ready" || state === "done" || state === "rejected") && (
          <div style={{ marginBottom: 16 }}>
            {row("№ документа / Hujjat", info.deliveryNumber)}
            {row("Отправитель / Yuboruvchi", info.sender)}
            {row("Получатель / Qabul qiluvchi", info.recipientName)}
            {row("Адрес / Manzil", info.recipientAddress)}
            {row("Отправлено / Yuborilgan", info.shippedAt ? new Date(info.shippedAt).toLocaleString("ru") : "")}
            {row("Водитель / Haydovchi", [info.driverName, info.driverPhone, info.vehicleInfo].filter(Boolean).join(" · "))}
            {row("Позиций / Tovarlar", info.items)}
            {/* tog'a #2813 (12-band, 2026-09-25): yuk tarkibi — nomi, artikuli, soni (narxsiz) */}
            {Array.isArray(info.lines) && info.lines.length > 0 && (
              <table style={{ width: "100%", borderCollapse: "collapse", marginTop: 8, fontSize: 14 }} data-testid="delivery-lines">
                <thead>
                  <tr style={{ color: "#64748b", textAlign: "left" }}>
                    <th style={{ padding: "4px 6px", borderBottom: "1px solid #e2e8f0" }}>Товар / Tovar</th>
                    <th style={{ padding: "4px 6px", borderBottom: "1px solid #e2e8f0", textAlign: "right" }}>Кол-во / Soni</th>
                  </tr>
                </thead>
                <tbody>
                  {info.lines.map((l: any, i: number) => (
                    <tr key={i}>
                      <td style={{ padding: "4px 6px", borderBottom: "1px solid #f1f5f9" }}>
                        {l.name || "—"}{l.article ? <span style={{ color: "#94a3b8" }}> · {l.article}</span> : null}
                      </td>
                      <td style={{ padding: "4px 6px", borderBottom: "1px solid #f1f5f9", textAlign: "right", whiteSpace: "nowrap" }}>{l.qty}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        )}
        {/* tog'a #342 / katalog #6024: yo'lda — haydovchi qayerda va taxminan qachon yetib keladi (server faqat yangi GPS bo'lsa beradi) */}
        {state === "ready" && info?.status === 1 && info?.lastLat != null && (
          <div style={{ marginBottom: 14 }} data-testid="delivery-live">
            <div style={{ fontSize: 14, fontWeight: 600, marginBottom: 6 }}>
              🚚 {info.etaMin ? `Прибудет примерно через ${info.etaMin} мин / Taxminan ${info.etaMin} daqiqada` : "Водитель в пути / Haydovchi yo'lda"}
              <span style={{ display: "block", fontSize: 12, fontWeight: 400, color: "#64748b" }}>
                GPS: {new Date(info.lastLocationAt).toLocaleTimeString("ru", { hour: "2-digit", minute: "2-digit" })}
              </span>
            </div>
            <iframe
              title="map"
              src={yandexWidget([`${info.lastLon},${info.lastLat},pm2blm`, info.destLat != null ? `${info.destLon},${info.destLat},pm2rdm` : ""].filter(Boolean))}
              style={{ width: "100%", height: 240, border: 0, borderRadius: 10 }}
            />
          </div>
        )}
        {state === "ready" && (
          <>
            <div style={{ display: "flex", gap: 10, marginBottom: 14 }}>
              <button style={btn("#16a34a")} disabled={busy} onClick={confirm}>
                ✅ Получил<br /><span style={{ fontSize: 12, fontWeight: 400 }}>Yetib keldi</span>
              </button>
              <button style={btn("#dc2626")} disabled={busy} onClick={reject}>
                ❌ Не получил<br /><span style={{ fontSize: 12, fontWeight: 400 }}>Kelmadi</span>
              </button>
            </div>
            <textarea
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              placeholder="Причина отказа (если не получили) / Rad sababi"
              rows={3}
              style={{ width: "100%", boxSizing: "border-box", padding: 10, borderRadius: 8, border: "1px solid #cbd5e1", fontSize: 14 }}
            />
          </>
        )}
        {state === "done" && <p style={{ color: "#15803d", fontSize: 16, fontWeight: 600 }}>✅ Спасибо! Получение подтверждено. / Rahmat! Qabul qilinganligi tasdiqlandi.</p>}
        {state === "rejected" && <p style={{ color: "#b91c1c", fontSize: 16, fontWeight: 600 }}>❌ Отказ зафиксирован, отправитель уведомлён. / Rad etildi, yuboruvchiga xabar berildi.</p>}
      </div>
    </div>
  )
}
